<div
  *ngIf="!node.header && !multiSelect"
  class="single-select-node"
  [class.selected]="node.selected"
  [class.highlighted]="node.highlighted"
  [class.disabled]="disabled || node.disabled"
  (click)="selectedChanged(true)"
>
  <riv-icon
    class="checkmark"
    [name]="'Check'"
    *ngIf="node.selected"
    [size]="16"
  ></riv-icon>
  <ng-container
    *ngTemplateOutlet="label; context: { $implicit: node }"
  ></ng-container>
</div>
<div
  #optionNode
  style="width: 100%"
  *ngIf="!node.header && multiSelect"
  class="multi-select-node"
  [class.selected]="node.selected"
  [class.highlighted]="node.highlighted"
>
  <riv-checkbox
    class="checkbox"
    [disabled]="disabled || node.disabled || (node.selected && atMinSelected)"
    [value]="node.selected || all"
    (valueChange)="selectedChanged($event)"
    [identifier]="node.id"
  >
    <ng-container
      *ngTemplateOutlet="label; context: { $implicit: node }"
    ></ng-container>
  </riv-checkbox>
</div>
<div *ngIf="node.header" class="single-select-node header">
  <span class="label" [title]="getTooltipFromNode(node, displayId)">
    <span class="label-id rv-bold" *ngIf="displayId"> {{ node.id }} - </span>
    <span class="label-title">
      {{ node.title }}
    </span>
    <span *ngIf="node.subtitle" class="label-subtitle">
      {{ node.subtitle }}
    </span>
  </span>
</div>
<ng-template #label let-node>
  <avatar *ngIf="showAvatars" [avatarState]="node.avatarState"></avatar>
  <span
    class="label"
    [class.max-width]="draggable || actionButton || node.count != undefined"
    [title]="getTooltipFromNode(node, displayId)"
  >
    <span class="label-id rv-bold" *ngIf="displayId"> {{ node.id }} - </span>
    <span class="label-title">
      <fuzzy-highlight
        [text]="node.title"
        [indices]="node.titleHighlightIndices"
      ></fuzzy-highlight>
    </span>
    <span *ngIf="node.subtitle" class="label-subtitle">
      <fuzzy-highlight
        [text]="node.subtitle"
        [indices]="node.subtitleHighlightIndices"
      ></fuzzy-highlight>
    </span>
    <riv-badge
      *ngIf="node.auto"
      [size]="'medium'"
      [variant]="'categorical-9'"
      style="margin-left: 10px"
    >
      Auto
    </riv-badge>
    <riv-badge
      *ngIf="node.showBadge && node.badgePosition !== 'footer'"
      [size]="'xsmall'"
      class="option-badge"
      [variant]="disabled || node.disabled ? 'disabled' : 'brand-dark'"
    >
      <span truncate>{{ node.badgeText }}</span>
    </riv-badge>
    <div>
      <fuzzy-highlight
        *ngIf="node.subtext"
        class="rv-explanation"
        [text]="node.subtext"
        [indices]="node.subtextHighlightIndices"
      ></fuzzy-highlight>
    </div>
    <riv-badge
      *ngIf="node.showBadge && node.badgePosition === 'footer'"
      [size]="'xsmall'"
      class="option-badge"
      [variant]="disabled || node.disabled ? 'disabled' : 'brand-dark'"
    >
      <span truncate>{{ node.badgeText }}</span>
    </riv-badge>
  </span>
  <ng-container *ngIf="draggable" class="rv-flex flex-nowrap">
    <riv-icon
      cdkDrag
      cdkDragRootElement=".option-node"
      [cdkDragDisabled]="!draggable"
      cdkDragHandle
      [name]="'Reorder'"
      [size]="16"
      class="reorder"
    >
      <div class="drag-placeholder" *cdkDragPlaceholder></div>
    </riv-icon>
    <ng-container *ngIf="pinned; else unpinned">
      <riv-icon
        class="ml-large rv-right pin-icon"
        [name]="'PinActive'"
        (click)="pinThis($event); (false)"
        [size]="16"
      ></riv-icon>
    </ng-container>
    <ng-template #unpinned>
      <riv-icon
        class="ml-large rv-right pin-icon"
        [name]="'PinInactive'"
        (click)="pinThis($event); (false)"
        [size]="16"
      ></riv-icon>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="actionButton">
    <riv-icon
      class="ml-large rv-right pin-icon"
      [rivTooltip]="actionButton.tooltip"
      [name]="actionButton.icon || 'MoreVertical'"
      (click)="actionButton.onClick(node.id)"
      [size]="16"
    ></riv-icon>
  </ng-container>

  <span class="count">{{ node.count | rivNumber }}</span>
</ng-template>
